<div
    class="row"
    id="{{tool.type}}FeatureTable">
    <div class="col-xs-12 mgb10">
        <div class="feature-table-total pull-left">
            <div title="Total number of features">
                <span class="badge">{{attrsList?.length || 0}}</span> features
            </div>
            <div title="Number of features selected in the list">
                <span class="badge">{{selectedAttrsList.length}}</span> selected
            </div>
        </div>
        <div class="feature-table-tools pull-right">
            @if (tool.permissions | hasPermissions) {
                <button
                    type="button"
                    id="attributeEditorDeleteBtn"
                    class="btn btn-default nlr-icon-btn"
                    title="Delete selected features"
                    [disabled]="isDisabled() || isReadOnly() || (tool.permissions | disabledByPermissions)"
                    (click)="deleteSelectedFeatures()">
                    <i class="nlrp-icon nlrp-icon-trash"></i>
                </button>
            }

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                id="attributeEditorHideBtn"
                title="Hide unselected features"
                [disabled]="disabled"
                (click)="hideShowUnselectedRows()"
                [ngClass]="{active: hideUnselectedRows}">
                <i class="nlrp-icon nlrp-icon-compress-selected-feature-list"></i>
            </button>

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                id="attributeEditorClearBtn"
                title="Clear selected features"
                [disabled]="disabled"
                (click)="clearAllRows()">
                <i class="nlrp-icon nlrp-icon-remove-circle"></i>
            </button>

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                id="attributeEditorFilterButton"
                title="Open/Close feature filter"
                [disabled]="disabled"
                [ngClass]="{active: showFilter || filterApplied}"
                (click)="showFilter = !showFilter;"
                cdkOverlayOrigin
                #showFilterTrigger="cdkOverlayOrigin"
                data-cdkOverlayContainerSelector="#attributeViewerOverlayContainer">
                <i class="nlrp-icon nlrp-icon-filter-off"></i>
            </button>

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                id="attributeEditorColumnButton"
                title="Open/close column chooser"
                [disabled]="disabled"
                [ngClass]="{active: showColumnSettings}"
                (click)="showColumnSettings = !showColumnSettings;"
                cdkOverlayOrigin
                #showColumnSettingsTrigger="cdkOverlayOrigin"
                data-cdkOverlayContainerSelector="#attributeViewerOverlayContainer">
                <i class="nlrp-icon nlrp-icon-column-chooser"></i>
            </button>

            @if (['EDIT_DESIGN', 'VIEW_DESIGN'] | hasPermissions) {
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn mgl10"
                    title="{{getAttributeEditorTooltip()}}"
                    id="attributeEditorToolBtn"
                    [ngClass]="{'active': isEditorActive()}"
                    (click)="openEditor();"
                    [disabled]="editAttributesIsDisabled() || (['EDIT_DESIGN', 'VIEW_DESIGN'] | disabledByPermissions)"
                    cdkOverlayOrigin
                    #showAttributeEditorTrigger="cdkOverlayOrigin"
                    data-cdkOverlayContainerSelector="#attributeViewerOverlayContainer">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </button>
                <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayPanelClass]="'widgets'"
                    [cdkConnectedOverlayOrigin]="showAttributeEditorTrigger"
                    [cdkConnectedOverlayOpen]="isEditorActive() && tool.useDefaultEditor && isDesignTabActive">
                    <div
                        id="{{tool.type}}AttributeEditor"
                        class="feature-editor"
                        [ngStyle]="editorConfig.style"
                        cdkDrag
                        [cdkDragConstrainPosition]="computeEditorDragPosition"
                        (click)="onClickAttributeEditor()">
                        <div
                            class="col-xs-12 widget-header"
                            cdkDragHandle>
                            <span>Attribute editor</span>
                            <div class="pull-right btn-group btn-group-xs">
                                <nlrp-help-link
                                    [url]="getAttributeEditorHelpUrl()"
                                    [pageTitle]="getAttributeEditorHelpPageTitle()"></nlrp-help-link>
                                <i
                                    class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                                    title="Close"
                                    (click)="closeEditor()"></i>
                            </div>
                        </div>
                        <div class="widget-content">
                            <div class="col-xs-12">
                                <p></p>
                            </div>
                            <form
                                id="{{tool.type}}EditorForm"
                                name="editorForm"
                                novalidate
                                autocomplete="off"
                                #editorForm="ngForm">
                                @if (invalidSelectedFeaturesError) {
                                    <div class="help-block">
                                        <span>Error!</span>
                                        <span>{{invalidSelectedFeaturesError}}</span>
                                    </div>
                                }
                                <div class="col-xs-12">&nbsp;</div>
                                @for (attribute of getEditorAttributes(); track attribute) {
                                    <div>
                                        @if (
                                            (tool.permissions | hasPermissions) &&
                      attribute.attributeType &&
                      attribute.attributeType === 'DOMAIN' &&
                      (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': domainAttributeSelect | formFieldHasError}">
                                                <label
                                                    for="{{tool.type + attribute.prop}}"
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                    {{attribute.name}}
                                                </label>
                                                <div class="input-group">
                                                    <ng-select
                                                        class="nlr-ng-select"
                                                        [searchable]="false"
                                                        [clearable]="false"
                                                        [id]="tool.type + attribute.prop"
                                                        [name]="tool.type + attribute.prop"
                                                        [attr.name]="tool.type + attribute.prop"
                                                        [title]="'Select ' + attribute.name"
                                                        [disabled]="attribute.disabled || disabled || (attribute.prop !== 'type' && !attribute.editable) ||
                                                    (tool.permissions | disabledByPermissions)"
                                                        placeholder="Select"
                                                        [items]="attribute.values"
                                                        bindLabel="description"
                                                        [(ngModel)]="attribute.value"
                                                        [required]="isAttributeRequired(attribute)"
                                                        (change)="attributeSelectorChanged(attribute)"
                                                        #domainAttributeSelect="ngModel">
                                                    </ng-select>
                                                </div>
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) && attribute.attributeType &&
                      attribute.attributeType === 'BOOLEAN' &&
                      (selectedAttrsList.length === 0 || (selectedAttrsList.length === 1 || attribute.bulkUpdate))
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': booleanAttributeInput | formFieldHasError}">
                                                <div
                                                    class="checkbox mg0 l130"
                                                    title="{{attribute.name}}">
                                                    <div class="checkbox-inline">
                                                        <i
                                                            class="nlrp-icon"
                                                            [ngClass]="{'active': attribute.value === 'Yes' || attribute.value === true,
                                                        'nlrp-icon-check-box-selected' : attribute.value === 'Yes' || attribute.value === true,
                                                        'nlrp-icon-check-box-unselected': !(attribute.value === 'Yes' || attribute.value === true)}"
                                                            (click)="attribute.value = !attribute.value"></i>
                                                        <input
                                                            type="checkbox"
                                                            id="{{tool.type + attribute.prop}}"
                                                            [attr.name]="tool.type + attribute.prop"
                                                            [name]="tool.type + attribute.prop"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="isAttributeRequired(attribute)"
                                                            [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                            #booleanAttributeInput="ngModel"
                                                            style="visibility: hidden;" />
                                                    </div>
                                                </div>
                                                <label
                                                    class="checkbox-label"
                                                    for="{{tool.type + attribute.prop}}">
                                                    {{attribute.name}}
                                                </label>
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) && attribute.attributeType &&
                      attribute.attributeType === 'RADIO' &&
                      (selectedAttrsList.length === 0 || (selectedAttrsList.length === 1 || attribute.bulkUpdate))
                                        ) {
                                            <div class="col-xs-12 p0 mgb10">
                                                <label
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}"
                                                    for="{{tool.type + attribute.prop}}">
                                                    {{attribute.name}}
                                                </label>
                                                @for (option of attribute.values; track option) {
                                                    <label
                                                        title="Select {{attribute.name}}"
                                                        class="nlr-radio"
                                                        [ngClass]="{
                                                'has-error': radioAttributeInput | formFieldHasError,
                                                'nlr-radio-required-error': !attribute.value && editorForm.submitted && isAttributeRequired(attribute)
                                            }">
                                                        <input
                                                            id="{{tool.type + attribute.prop}}"
                                                            type="radio"
                                                            [attr.name]="tool.type + attribute.prop"
                                                            [name]="tool.type + attribute.prop"
                                                            [value]="option.value"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="isAttributeRequired(attribute)"
                                                            [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                            #radioAttributeInput="ngModel" />
                                                        <span>{{option.description}}</span>
                                                    </label>
                                                }
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) && attribute.attributeType &&
                      attribute.attributeType.includes('STRING') && attribute.dms && attribute.attributeTypeLength <= 20 &&
                      (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': dmsAttributeInput | formFieldHasError}">
                                                <label
                                                    for="{{tool.type + attribute.prop}}"
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                    {{attribute.name}}
                                                </label>
                                                <div class="input-group">
                                                    <span class="input-group-addon">
                                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                                    </span>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="{{tool.type + attribute.prop}}"
                                                        [attr.name]="tool.type + attribute.prop"
                                                        [name]="tool.type + attribute.prop"
                                                        [(ngModel)]="attribute.value"
                                                        [required]="isAttributeRequired(attribute)"
                                                        maxlength-input-limit="{{attribute.attributeTypeLength}}"
                                                        placeholder="Enter {{attribute.name}}"
                                                        title="Enter {{attribute.name}}"
                                                        nlrAnglePattern
                                                        autocomplete="off"
                                                        [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                        #dmsAttributeInput="ngModel" />
                                                </div>
                                                @if (dmsAttributeInput | formFieldHasError) {
                                                    <div class="help-block">
                                                        <span>Invalid!</span>
                                                        <span>Enter value in D.MMSS format: D=0-359, MM=00-59, SS=00-59</span>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) &&
                      attribute.attributeType && attribute.attributeType.includes('STRING') &&
                      !attribute.dms && attribute.attributeTypeLength <= 20 &&
                      (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': stringAttributeInput | formFieldHasError}">
                                                <label
                                                    for="{{tool.type + attribute.prop}}"
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                    {{attribute.name}}
                                                </label>
                                                <div class="input-group">
                                                    <span class="input-group-addon">
                                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                                    </span>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="{{tool.type + attribute.prop}}"
                                                        [attr.name]="tool.type + attribute.prop"
                                                        [name]="tool.type + attribute.prop"
                                                        [(ngModel)]="attribute.value"
                                                        [required]="isAttributeRequired(attribute)"
                                                        [maxLengthInputLimit]="attribute.attributeTypeLength"
                                                        placeholder="Enter {{attribute.name}}"
                                                        title="Enter {{attribute.name}}"
                                                        autocomplete="off"
                                                        [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                        [nlrPattern]="attribute.pattern"
                                                        #stringAttributeInput="ngModel" />
                                                </div>
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) &&
                      attribute.attributeType && attribute.attributeType.includes('STRING') &&
                      attribute.attributeTypeLength > 20 &&
                      (attribute.parentAttribute === null || attribute.showBasedOnParent) &&
                      (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': stringAttributeTextarea | formFieldHasError}">
                                                <label
                                                    for="{{tool.type + attribute.prop}}"
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                    {{attribute.name}}
                                                </label>
                                                <div class="input-group">
                                                    <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                                                    <textarea
                                                        id="{{tool.type + attribute.prop}}"
                                                        class="form-control"
                                                        placeholder="Enter {{attribute.name}}"
                                                        title="Enter {{attribute.name}}"
                                                        rows="4"
                                                        [attr.name]="tool.type + attribute.prop"
                                                        [name]="tool.type + attribute.prop"
                                                        [(ngModel)]="attribute.value"
                                                        [required]="isAttributeRequired(attribute)"
                                                        [readonly]="attribute.readyOnlyBasedOnParent"
                                                        [maxLengthInputLimit]="attribute.attributeTypeLength"
                                                        [maxlength]="attribute.attributeTypeLength"
                                                        [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                        #stringAttributeTextarea="ngModel">
                                                    </textarea>
                                                </div>
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) &&
                      attribute.attributeType && attribute.attributeType.includes('INTEGER') &&
                      (selectedAttrsList.length === 0 || (selectedAttrsList.length === 1 || attribute.bulkUpdate))
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': integerAttributeInput | formFieldHasError}">
                                                <label
                                                    for="{{tool.type + attribute.prop}}"
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                    {{attribute.name}}
                                                </label>
                                                <div class="input-group">
                                                    <span class="input-group-addon">
                                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                                    </span>
                                                    <input
                                                        type="number"
                                                        class="form-control"
                                                        id="{{tool.type + attribute.prop}}"
                                                        placeholder="Enter {{attribute.name}}"
                                                        title="Enter {{attribute.name}}"
                                                        [attr.name]="tool.type + attribute.prop"
                                                        [name]="tool.type + attribute.prop"
                                                        [(ngModel)]="attribute.value"
                                                        [required]="isAttributeRequired(attribute)"
                                                        [nlrPattern]="attribute.pattern"
                                                        [min]="attribute.min"
                                                        [max]="attribute.max"
                                                        [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                        #integerAttributeInput="ngModel" />
                                                </div>
                                            </div>
                                        }
                                        @if (
                                            (tool.permissions | hasPermissions) &&
                      attribute.attributeType && attribute.attributeType.includes('DECIMAL') &&
                      (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                        ) {
                                            <div
                                                class="col-xs-12 p0 mgb10"
                                                [ngClass]="{'has-error': decimalAttributeInput | formFieldHasError}">
                                                <label
                                                    for="{{tool.type + attribute.prop}}"
                                                    class="control-label"
                                                    [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                    {{attribute.name}}
                                                </label>
                                                <div class="input-group">
                                                    <span class="input-group-addon">
                                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                                    </span>
                                                    <input
                                                        type="number"
                                                        class="form-control"
                                                        id="{{tool.type + attribute.prop}}"
                                                        placeholder="Enter {{attribute.name}}"
                                                        title="Enter {{attribute.name}}"
                                                        step="0.01"
                                                        [attr.name]="tool.type + attribute.prop"
                                                        [name]="tool.type + attribute.prop"
                                                        [(ngModel)]="attribute.value"
                                                        [required]="isAttributeRequired(attribute)"
                                                        [nlrPattern]="attribute.pattern"
                                                        [disabled]="!attribute.editable || disabled || (tool.permissions | disabledByPermissions)"
                                                        #decimalAttributeInput="ngModel" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </form>
                        </div>
                        <div class="col-xs-12 widget-footer">
                            @if (tool.permissions | hasPermissions) {
                                <button
                                    type="button"
                                    class="btn btn-default nlr-btn-sm"
                                    id="applyBtn"
                                    title="Apply"
                                    (click)="saveEditor()"
                                    [disabled]="isDisabled() || (tool.permissions | disabledByPermissions)">
                                    Apply
                                </button>
                            }
                            <button
                                type="button"
                                class="btn btn-warning nlr-btn-sm"
                                id="closeBtn"
                                title="Close"
                                (click)="closeEditor()">
                                Close
                            </button>
                        </div>
                    </div>
                </ng-template>
            }
        </div>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayPanelClass]="'widgets'"
        [cdkConnectedOverlayOrigin]="showColumnSettingsTrigger"
        [cdkConnectedOverlayOpen]="showColumnSettings">
        <div
            id="{{tool.type}}ColumnSettingsFeatureWidget"
            class="feature-column-settings"
            cdkDrag
            [cdkDragConstrainPosition]="computeDragPosition"
            (click)="onClickColumnSettingsWidget()">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>Select columns</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="getColumnChooserHelpUrl()"
                        [pageTitle]="getColumnChooserHelpPageTitle()"></nlrp-help-link>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        title="Close"
                        (click)="showColumnSettings = false"></i>
                </div>
            </div>
            <div class="widget-content">
                <div class="col-xs-12">
                    <h6>Select the columns to be displayed.</h6>
                </div>
                @for (attribute of getAttributesVisibilityAllowed(); track attribute) {
                    <div
                        [ngClass]="{disabled: !attribute.hideColumn}"
                        (click)="showOrHideColumn(attribute)">
                        <i
                            class="nlrp-icon"
                            [ngClass]="{'active': attribute.display,
                            'nlrp-icon-check-box-selected': attribute.display,
                            'nlrp-icon-check-box-unselected': !attribute.display}"
                            tabindex="0"
                            title="Show/hide attribute"></i>
                        <span tabindex="0">{{attribute.name}}</span>
                    </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayPanelClass]="'widgets'"
        [cdkConnectedOverlayOrigin]="showFilterTrigger"
        [cdkConnectedOverlayOpen]="showFilter">
        <div
            id="{{tool.type}}FilterFeaturesWidget"
            class="feature-filter-settings"
            cdkDrag
            [cdkDragConstrainPosition]="computeDragPosition"
            (click)="onClickFilterFeaturesWidget()">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>Filter list</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="getFilterHelpUrl()"
                        [pageTitle]="getFilterHelpPageTitle()"></nlrp-help-link>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        title="Close"
                        (click)="showFilter = false"></i>
                </div>
            </div>
            <div class="widget-content container-fluid">
                <div class="row">
                    <div class="col-xs-12">
                        <h6>Enter filter selection criteria.</h6>
                    </div>
                </div>
                @for (attribute of options.columns; track attribute) {
                    <div class="row">
                        <div class="col-xs-5">
                            <label class="control-label">{{attribute.name}}</label>
                        </div>
                        <div class="col-xs-7">
                            <div class="input-group">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit"></i>
                                </span>
                                <input
                                    type="text"
                                    [attr.name]="attribute.prop"
                                    [name]="attribute.prop"
                                    class="form-control"
                                    [(ngModel)]="attribute.filterValue"
                                    autocomplete="off"
                                    [nlrTypehead]="filterFeaturesSearch(attribute)"
                                    placeholder="Enter {{attribute.name}}"
                                    title="Select {{attribute.name}}"
                                    [disabled]="disabled" />
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-search"></i></span>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="col-xs-12 widget-footer">
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    id="applyFilterSettingBtn"
                    title="Apply filter settings"
                    [disabled]="disabled"
                    (click)="applyFilter()">
                    Apply
                </button>
                <button
                    type="button"
                    class="btn btn-warning nlr-btn-sm"
                    id="closeFilterSettingBtn"
                    title="Close filter settings"
                    [disabled]="disabled"
                    (click)="showFilter = false">
                    Close
                </button>
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    id="clearFilterSettingBtn"
                    title="Clear filter settings"
                    [disabled]="disabled"
                    (click)="clearFilter()">
                    Clear
                </button>
            </div>
        </div>
    </ng-template>

    <div class="col-xs-12">
        <ngx-datatable
            #dataTable
            class="material"
            [messages]="options.messages"
            [rows]="attrsList"
            [columns]="options.columns"
            [columnMode]="ColumnMode.force"
            [selected]="selectedAttrsList"
            [selectionType]="SelectionType.multi"
            [rowHeight]="30"
            [headerHeight]="32"
            [footerHeight]="0"
            [scrollbarH]="true"
            [scrollbarV]="true"
            [sortType]="SortType.multi"
            [enableClearingSortState]="true"
            [trackByProp]="'id'"
            (select)="onTableSelect($event)"
            (activate)="onActivate($event)"
            (sort)="onSort($event)">
        </ngx-datatable>
    </div>
</div>
